import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
// import Paper from '@mui/material/Paper';
// import Draggable from 'react-draggable';
import ButtonAction from '../Button.js/SaveButton';
import { useTranslation } from 'react-i18next';
import Loader from '../loader/loader';
import { Alert } from '@mui/material';
import { KeysConfigDevice } from 'src/utils/keys';
// function PaperComponent({ ...props }) {
//     return (
//         <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
//             <Paper {...props} />
//         </Draggable>
//     );
// }

export default function ConfirmSyncListUser({ visible = false, setVisible, handleSave, loading, data }) {
    const { t } = useTranslation();
    const Keys = KeysConfigDevice;

    console.log('ConfirmSyncListUser', data);

    return (
        <div>
            <Dialog open={visible} onClose={() => setVisible(false)} aria-labelledby="draggable-dialog-title">
                {/* <Loader loading={loading} /> */}
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    {t('message_sync_list_user')}
                </DialogTitle>
                <DialogContent>
                    {data[Keys.status_key_sync_hikvision] === 's01' ? (
                        <>
                            <Alert severity="warning" style={{ marginBottom: '20px' }}>
                                {t('notification_sync_running')}
                            </Alert>
                        </>
                    ) : (
                        <>
                            <DialogContentText>{t('message_confirm_sync')}</DialogContentText>
                            <Alert severity="warning" style={{ marginBottom: '20px' }}>
                                {t('message_warning')}
                            </Alert>
                        </>
                    )}
                </DialogContent>
                <DialogActions>
                    <ButtonAction
                        title={t('cancel')}
                        onClick={() => setVisible(false)}
                        // variant="text"
                        type="cancel"
                    />
                    {data[Keys.status_key_sync_hikvision] !== 's01' && <ButtonAction title={t('save')} type="save" onClick={handleSave} />}
                </DialogActions>
            </Dialog>
        </div>
    );
}
